'use client';

import * as React from 'react';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useTranslation } from 'react-i18next';
import type { ErrorInfo } from 'next/error';
import Block from '@/components/ui/Block';
import NonIdealState from '@/components/ui/NonIdealState';
import { notFoundImage } from '@/lib/helpers/hardcodedImages';

type ErrorStateProps = Pick<ErrorInfo, 'error'>;

const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
  const { t } = useTranslation();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Block>
      <h1 className="hidden">{t('components.serverError.title')}</h1>
      <NonIdealState
        title={t('components.serverError.title')}
        description={t('components.serverError.description')}
        imageUrl={notFoundImage()}
      />
    </Block>
  );
};

ErrorState.displayName = 'ErrorState';

export default ErrorState;
